<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="8" sm="6">
        <v-autocomplete
          name="partner"
          :items="partners"
          :label="$t('manual_order.select_partner')"
          :item-text="
            (item) =>
              `${item.company ? item.company.name : null} - ${item.forename} ${
                item.surname
              } (${item.email})`
          "
          @change="setPartner($event)"
          item-value="id"
          justify="start"
          v-model="partner"
        >
        </v-autocomplete>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Partner",
  data() {
    return {
      partner: {},
    };
  },
  computed: {
    partners() {
      return this.$store.getters.partners;
    },
  },
  methods: {
    setPartner(value) {
      this.$store.commit("setPartner", value);
    },
  },
  mounted() {
    this.$store.dispatch("loadUsers", true);
    this.partner = this.$store.state.configurator.partner;
  },
};
</script>

<style scoped>
</style>
